import { provideEffects } from '@ngrx/effects';
import { CategoryWifiProfileEffects } from './category-wifi-profile-preset-configuration.effects';

export const provideCategoryWifiProfilePresetConfigurationStore = () => [provideEffects([CategoryWifiProfileEffects])];
